export default {
  EMS: 'EMS',
  DEM: 'DEM',
  STATE: 'STATE',
};
